import styled from 'styled-components';
import { fontSize, space } from 'styled-system';
import tag from 'clean-tag';

const Heading = styled(tag)`
    ${fontSize};
    ${space};
`;

Heading.propTypes = {
    ...fontSize.propTypes,
    ...space.propTypes
};

Heading.defaultProps = {
    m: 2
};

export const H1 = styled(Heading)``;

H1.defaultProps = {
    is: 'h1',
    fontSize: 6
};

export const H2 = styled(Heading)``;

H2.defaultProps = {
    is: 'h2',
    fontSize: 4
};

export const H3 = styled(Heading)`
    text-transform: uppercase;
`;

H3.defaultProps = {
    is: 'h3',
    fontSize: 2
};



// WEBPACK FOOTER //
// ./src/uic/heading.js